import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { ConfluenceAccumulatedDataType } from './confluence-accumulated-data-type';

type ConfluenceDeepResearchCreatePageData = ConfluenceAccumulatedDataType & {
	title: string;
	content: string;
	contentId: string;
};

/**
 * Properties for the Confluence Deep Research page creation command.
 */
export interface ConfluenceDeepResearchPageCreateCommandProperties extends CommandProperties {
	key: string;
	data: ConfluenceDeepResearchCreatePageData;
	isStreamComplete: boolean;
}

/**
 * Command to request creation of a Confluence page using the Deep Research export payload.
 */
export const ConfluenceDeepResearchPageCreateCommand: CommandConstructor<
	ConfluenceDeepResearchPageCreateCommandProperties,
	SerializableValue
> = createCommand<ConfluenceDeepResearchPageCreateCommandProperties>(
	'confluence-deep-research-page-create-command',
);
